import { useState } from "react"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/modules/shared/ui/components/dialog"
import { Button } from "@/modules/shared/ui/components/button"
import { Textarea } from "@/modules/shared/ui/components/textarea"
import { Label } from "@/modules/shared/ui/components/label"

interface RejectCandidateDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: (reason: string) => Promise<void>
  candidateName: string
  isRejecting: boolean
}

export function RejectCandidateDialog({
  open,
  onOpenChange,
  onConfirm,
  candidateName,
  isRejecting,
}: RejectCandidateDialogProps) {
  const [reason, setReason] = useState("")

  const handleConfirm = async () => {
    if (reason.trim()) {
      await onConfirm(reason)
      setReason("")
    }
  }

  const handleCancel = () => {
    setReason("")
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px] bg-card">
        <DialogHeader>
          <DialogTitle>Reject Candidate</DialogTitle>
          <DialogDescription>
            Please provide a reason for rejecting {candidateName}
          </DialogDescription>
        </DialogHeader>

        <div className="py-4 space-y-4">
          <div className="space-y-2">
            <Label htmlFor="rejection-reason">Rejection Reason</Label>
            <Textarea
              id="rejection-reason"
              placeholder="Enter the reason for rejection..."
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              rows={5}
              disabled={isRejecting}
              className="resize-none"
            />
            <p className="text-xs text-muted-foreground">
              This information will be used for internal records
            </p>
          </div>
        </div>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={handleCancel}
            disabled={isRejecting}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={!reason.trim() || isRejecting}
            variant="destructive"
          >
            {isRejecting ? "Rejecting..." : "Reject Candidate"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
